const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "File Name",
    dataIndex: "file",
    render: defaultRender,
  },
  {
    title: 'File No.',
    dataIndex: 'file_number',
    render: defaultRender,
  },
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
];

export default columns;
